/* eslint-disable */

window.$ = jQuery;
require('slick-carousel/slick/slick.min');

const $chart = $('#chart-breakdown'),
      $text_column = $chart.find('.text-column').first(),
      $img_column = $chart.find('.img-column').first();

$text_column.find('> div').each( ( idx, div ) => {
    $(div).on('click', e => {
        $img_column.slick( 'slickGoTo', idx );
    });

    $(div).on('mouseenter', e => {
        $img_column.slick( 'slickPause' );
    });

    $(div).on('mouseleave', e => {
        $img_column.slick( 'slickPlay' );
    });

});

$img_column.on('init', ( e, slick ) => {
    $text_column.find('div:eq('+slick.currentSlide+')').addClass('current');
});

$img_column.on('beforeChange', ( e, slick, currSlide, nextSlide ) => {
    $text_column.find('.current').removeClass('current');
    $text_column.find('div:eq('+nextSlide+')').addClass('current');
});

$img_column.slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    infinite: true,
    cssEase: 'linear',
    draggable: true
});